import { InertiaLink, Link } from "@inertiajs/inertia-react";
import React, { useState } from "react";
import LandingLayout from "@/Layouts/LandingLayout";
import { Container } from "@/Components/Container";
import { FormError } from "@/Components/FormError";
import { Inertia } from "@inertiajs/inertia";
import { useTitle } from "@/Utilities/Hooks";
import { Input } from "@/Components/Form";
import { SuccessMessage } from "@/Components/Messages";
// import { FillBackground } from '@/Components/FillBackground'

export default function Login({ errors, flash }) {
  useTitle("Login");

  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");

  function handleLogin(e) {
    e.preventDefault();

    Inertia.post("/login", { email, password });
  }

  return (
    <Container size="max-w-2xl bg-white self-center md:dots-topright md:dots-bottomleft overflow-visible relative p-4 md:p-16 md:mt-10">
      <div className="flex flex-col items-start">
        <a href="/">
          <img
            className="mb-8 h-16 w-16 self-start"
            src="/images/logo_dark.png"
            alt="Gidås logo"
          />
        </a>
        <h1 className="header-1">Welcome to Emma</h1>
        <p>Sign in to get started on your Emission Accounting.</p>
      </div>
      <div className="mt-8">
        {flash.status && <SuccessMessage>{flash.status}</SuccessMessage>}
        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label>
              <span className="mb-1 block">E-mail</span>
              <Input
                name="email"
                type="email"
                placeholder="Enter e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <FormError error={errors.email} />
          </div>
          <div className="mb-4">
            <label>
              <span className="mb-1 block">Password</span>
              <Input
                name="password"
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            <FormError error={errors.password} />
          </div>
          <div className="flex flex-row justify-between">
            <div className="flex-shrink">
              <p>
                Problems signing in?{" "}
                <Link
                  href="/forgot-password"
                  className="underline hover:no-underline"
                >
                  Forgot password
                </Link>
              </p>
            </div>
            <div className="flex-shrink-0">
              <button className="btn">Sign in</button>
            </div>
          </div>
          {/* <InertiaLink className="ml-4" href="/forgot-password">
            Forgot your password?
          </InertiaLink> */}
        </form>
      </div>
      {/*<p className="my-12 rounded-full bg-primary-light p-2 px-4 text-left">*/}
      {/*  <span className="font-bold">New user?</span>{" "}*/}
      {/*  <InertiaLink className="underline hover:no-underline" href="/plans">*/}
      {/*    Create account here*/}
      {/*  </InertiaLink>*/}
      {/*</p>*/}
    </Container>
  );
}

Login.layout = (page) => <LandingLayout>{page}</LandingLayout>;
